import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import { InputMintDiv } from 'views/common-styled-components';
import uploadImage from 'images/upload.png';
import { fetchGetProfileView } from '../../profile-view.actions';
import { getEncryptedUserId } from '__utils/common-utils';
import ProfileViewSelector from '../../profile-view.selector';
import { propsToJS } from '__utils/immutable-to-js';
import { useDispatch, useSelector } from 'react-redux';
import { compareBusinessTypes, compareOtherTypes, compareServiceTypes } from '__utils/helpers';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { Row, Col } from 'antd';
import { LayoutContext } from 'components/app-routes';
import { PersonalInfoTab, ProfileSubmitButton } from '../personal-account-info/style';
import { DASHBOARD_EMPLOYEMENT_INPUTS, INCOME_SLABS, PROFILE_ONBOARDING_CTA, PROFILE_TABS } from '../constants';
import PreviewImg from 'components/preview-image';
import FileUpload from 'components/file-upload';
import MobileFooterLayout from 'components/old-footer-layout';
import { MY_PROFILE_HEADER } from 'constants/header-titles';



const EmployementInfo: React.FC = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    // eslint-disable-next-line
    const { SetLayoutProps } = React.useContext(LayoutContext);

    const { profileView } = propsToJS(useSelector(ProfileViewSelector));

    useEffect(() => {
        SetLayoutProps({
            config: { title: MY_PROFILE_HEADER }
        })
        dispatch(fetchGetProfileView(getEncryptedUserId()));
        Mixpanel.track(getEventName("employementDetails", "loaded", "profile"));
    }, []);

    const returnProfileViewInputs = (inputName: string) => {
        if (profileView) {
            if (inputName === 'occupation') {
                if (compareBusinessTypes(profileView?.occupationType)) return 'Business'
                else if (compareServiceTypes(profileView?.occupationType)) return 'Service'
                else if (compareOtherTypes(profileView?.occupationType)) return 'Others'
            }
            else if (inputName === 'incomeSlab') {
                return INCOME_SLABS.find((element: any) => element.value.includes(profileView?.incomeSlab))?.name
            }
            else if (inputName === 'idType') return 'Adhaar Card'
        }
        return profileView[inputName]
    }

    return (<div>
        <PersonalInfoTab>
            {isMobile && <div>
                <h3>{PROFILE_TABS[2].label}</h3>
            </div>}
            <form name="bankDetailsForm">
                <Row gutter={[32, 16]}>
                    {
                        DASHBOARD_EMPLOYEMENT_INPUTS.map((inputElement, index) =>
                        (<Col xs={24} md={12} key={index}>
                            <InputMintDiv>
                                <label>{inputElement.title}</label>
                                <br />
                                <input
                                    {...inputElement}
                                    defaultValue={profileView && returnProfileViewInputs(inputElement.name)}
                                />
                            </InputMintDiv>
                        </Col>
                        ))
                    }

                    <Col xs={24} md={12}>
                        <label>Signature</label><br />
                        <div className='mt4'>
                            <FileUpload
                                name="signatureURL"
                                className="uploadImgCls"
                                id="signatureFile"
                                accept='image/*'
                                isUploaded={profileView?.signatureURL}
                                disabled
                            >
                                <div className='disabledlabelForFileInput'>
                                    <img src={uploadImage} alt="upload"></img>
                                    <p>Upload File</p>
                                </div>
                            </FileUpload>
                        </div>

                        {profileView?.signatureURL && <div className='cancelled-cheque-wrapper'>
                            <PreviewImg
                                showUpdateDiv={false}
                                id={"uploadImgFile"}
                                imgUrl={profileView?.signatureURL}
                            />
                        </div>
                        }
                    </Col>
                </Row>
            </form>

            <div className='account-btn-wrapper'>
                {profileView?.registeredWithBse !== 3 && <ProfileSubmitButton onClick={(event: any) => history.push('/profile/kyc-details?flowType=checkout')} isMobile={isMobile} type="button">{PROFILE_ONBOARDING_CTA}</ProfileSubmitButton>}
            </div>
            <MobileFooterLayout />

        </PersonalInfoTab>
    </div>);
};

export default EmployementInfo;

